import { SharedUserFilterObj, UserFilterObj } from 'st-app/api';
import { Signal, createSignal } from "solid-js";


export class FilterInfoInstance extends UserFilterObj {
    isDeleted = createSignal(false);
    isEnabled = createSignal(false);
    isDropTarget = createSignal(false);

    name$: Signal<string> = createSignal('');

    constructor(filter: UserFilterObj) {
        super();
        Object.assign(this, filter);

        this.name$[1](this.name || '');

        this.setEnabled(this.enabled);
    }

    setEnabled(enabled: boolean) {
        this.isEnabled[1](enabled);
    }

    toggleEnabled() {
        this.isEnabled[1](!this.isEnabled[0]());
    }

    toggleDeleted() {
        this.isDeleted[1](!this.isDeleted[0]());
    }
}

export class SharedFilterInstance extends FilterInfoInstance {
    fromUser?: string;

    constructor(filter: SharedUserFilterObj) {
        super(filter);
        Object.assign(this, filter);
    }
}
